import { ActionContext } from "vuex";
import { State as RootState } from "@/store/state";
import { GitLabState } from "@/store/gitlab/state";
import axios from "axios";
import { getStoreAccessors } from "typesafe-vuex";
import {
  commitSetAccessToken,
  commitSetBranch
} from "@/store/gitlab/mutations";

type GitLabContext = ActionContext<GitLabState, RootState>;
export const actions = {
  setAccessToken(context: GitLabContext, payload: string) {
    axios.defaults.headers["PRIVATE-TOKEN"] = payload;
    commitSetAccessToken(context, payload);
  },

  setBranch(context: GitLabContext, payload: string) {
    commitSetBranch(context, payload);
  }
};

const { dispatch } = getStoreAccessors<GitLabState, RootState>("");

export const dispatchSetAccessToken = dispatch(actions.setAccessToken);
export const dispatchSetBranch = dispatch(actions.setBranch);
